/* Scroll-lock rescue + cart repair.

   SCROLL BUG: the theme had two age gates. The old one inside cart.js keyed on
   sessionStorage 'gmc_age_ok' and added body.drawer-open (which sets
   overflow:hidden). The newer one keys on localStorage 'mw_age_ok'. Answering
   the visible gate cleared the new key but left body.drawer-open in place, so
   the page could not scroll. cart.js's gate is now switched off via
   themeCart.ageGate=false, and this file also strips any stale lock.

   CART BUGS: a rejected /cart/change.js (usually "only N in stock") returned an
   object with no items, which the old code fed to the badge and drawer, so the
   cart looked emptied. Fixed here, plus a remove button per line.
*/
(function () {
  'use strict';

  var cfg = window.themeCart || {};

  /* ---------- Scroll lock rescue ---------- */
  function noPanelOpen() {
    return !document.querySelector('#mini-cart-drawer.is-open') &&
           !document.querySelector('#categories-menu.is-open') &&
           !document.documentElement.classList.contains('age-locked') &&
           !(document.getElementById('quick-add-panel') && !document.getElementById('quick-add-panel').hidden);
  }
  function releaseScroll() {
    if (!noPanelOpen()) return;
    document.body.classList.remove('drawer-open');
    document.documentElement.classList.remove('age-locked');
    [document.body, document.documentElement].forEach(function (el) {
      if (el.style.overflow === 'hidden') el.style.removeProperty('overflow');
      if (el.style.position === 'fixed') el.style.removeProperty('position');
      if (el.style.height === '100%') el.style.removeProperty('height');
    });
    var g = document.getElementById('age-gate');
    if (g && !document.documentElement.classList.contains('age-locked')) g.hidden = true;
  }
  releaseScroll();
  document.addEventListener('DOMContentLoaded', function () { setTimeout(releaseScroll, 0); setTimeout(releaseScroll, 400); });
  window.addEventListener('pageshow', function () { setTimeout(releaseScroll, 0); });
  document.addEventListener('click', function () { setTimeout(releaseScroll, 60); });

  /* ---------- Money ---------- */
  function money(cents) {
    var f = cfg.moneyFormat || '${{amount}}';
    var n = (Number(cents) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    return f.replace(/\{\{\s*\w+\s*\}\}/, n);
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function setBadge(count) {
    var n = parseInt(count, 10);
    if (isNaN(n)) return;
    Array.prototype.forEach.call(document.querySelectorAll('.cart-count'), function (el) {
      el.textContent = n;
      el.style.removeProperty('display');
      el.setAttribute('data-cart-empty', n <= 0 ? 'true' : 'false');
      el.setAttribute('data-wide', String(n).length >= 4 ? 'true' : 'false');
    });
  }

  function notice(msg, isError) {
    var body = document.getElementById('mini-cart-body');
    if (!body) { if (isError) alert(msg); return; }
    var bar = body.querySelector('[data-cart-notice]');
    if (!bar) {
      bar = document.createElement('p');
      bar.setAttribute('data-cart-notice', '');
      body.insertBefore(bar, body.firstChild);
    }
    bar.className = isError ? 'form-error' : 'form-success';
    bar.textContent = msg;
    bar.style.margin = '0 0 12px';
    bar.style.fontSize = '13px';
    clearTimeout(bar._t);
    bar._t = setTimeout(function () { if (bar.parentNode) bar.parentNode.removeChild(bar); }, 5000);
  }

  function render(cart) {
    var body = document.getElementById('mini-cart-body');
    var totalEl = document.getElementById('mini-cart-total');
    if (!body || !cart || !cart.items) return;

    var focused = document.activeElement;
    var keepKey = null, selStart = null;
    if (focused && focused.hasAttribute && focused.hasAttribute('data-line-qty') && body.contains(focused)) {
      var st = focused.closest('.qty-stepper');
      keepKey = st ? st.dataset.lineKey : null;
      selStart = focused.selectionStart;
    }

    if (!cart.items.length) {
      body.innerHTML = '<p class="mini-cart-empty">Your cart is empty.</p>';
    } else {
      body.innerHTML = cart.items.map(function (item) {
        var img = item.image
          ? '<img src="' + item.image + '" alt="" width="56" height="56" loading="lazy">'
          : '<div class="mini-cart-item__noimg"></div>';
        var variant = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<span class="mini-cart-item__variant">' + item.variant_title + '</span>' : '';
        return '<div class="mini-cart-item" data-line-key="' + item.key + '">' +
            '<a href="' + item.url + '">' + img + '</a>' +
            '<div class="mini-cart-item__info">' +
              '<a href="' + item.url + '"><p class="mini-cart-item__title">' + item.product_title + '</p></a>' + variant +
              '<div class="qty-stepper" data-line-key="' + item.key + '">' +
                '<button type="button" class="qty-stepper__btn" data-action="decrease" aria-label="Decrease quantity">&minus;</button>' +
                '<input class="qty-stepper__num" type="text" inputmode="numeric" pattern="[0-9]*" value="' + item.quantity + '" data-line-qty aria-label="Quantity">' +
                '<button type="button" class="qty-stepper__btn" data-action="increase" aria-label="Increase quantity">+</button>' +
              '</div>' +
            '</div>' +
            '<span class="mini-cart-item__price">' + money(item.line_price) + '</span>' +
            '<button type="button" class="mini-cart-item__remove" data-remove-line="' + item.key + '" aria-label="Remove item" title="Remove">&times;</button>' +
          '</div>';
      }).join('');
    }

    if (totalEl) totalEl.textContent = money(cart.total_price);
    setBadge(cart.item_count);

    if (keepKey) {
      var back = body.querySelector('.qty-stepper[data-line-key="' + keepKey + '"] [data-line-qty]');
      if (back) {
        back.focus({ preventScroll: true });
        if (selStart != null) { try { back.setSelectionRange(selStart, selStart); } catch (e) {} }
      }
    }
  }

  function change(lineKey, quantity) {
    return fetch((cfg.routes && cfg.routes.cart_change) || '/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || !data || !data.items) {
          var msg = (data && (data.description || data.message)) || 'That quantity is not available.';
          return getCart().then(function (real) { render(real); notice(msg, true); return real; });
        }
        render(data);
        return data;
      });
    }).catch(function () {
      return getCart().then(function (real) {
        render(real);
        notice('Connection problem \u2014 your cart is unchanged.', true);
        return real;
      });
    });
  }

  var css = document.createElement('style');
  css.textContent =
    '.mini-cart-item { position: relative; padding-right: 26px; }' +
    '.mini-cart-item__remove {' +
      'position: absolute; top: 50%; right: 0; transform: translateY(-50%);' +
      'width: 24px; height: 24px; border: none; background: none; cursor: pointer;' +
      'font-size: 20px; line-height: 1; color: var(--text-muted); border-radius: 6px;' +
      'display: flex; align-items: center; justify-content: center; padding: 0; }' +
    '.mini-cart-item__remove:hover { background: var(--bg-light); color: #C62828; }' +
    '#mini-cart-body [data-cart-notice] { border-radius: 8px; padding: 9px 12px; }';
  document.head.appendChild(css);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var rm = e.target.closest('[data-remove-line]');
    if (rm) {
      e.preventDefault(); e.stopPropagation();
      change(rm.getAttribute('data-remove-line'), 0).then(function () { notice('Item removed.', false); });
      return;
    }

    var btn = e.target.closest('#mini-cart-body .qty-stepper__btn');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      var st = btn.closest('.qty-stepper');
      var input = st.querySelector('[data-line-qty]');
      var cur = parseInt(input.value, 10) || 1;
      var next = btn.dataset.action === 'increase' ? cur + 1 : cur - 1;
      if (next < 0) next = 0;
      change(st.dataset.lineKey, next);
      return;
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var el = e.target.closest ? e.target.closest('#mini-cart-body [data-line-qty]') : null;
    if (!el) return;
    e.preventDefault(); e.stopPropagation();
    var st = el.closest('.qty-stepper');
    var n = parseInt(String(el.value).replace(/[^0-9]/g, ''), 10);
    if (isNaN(n) || n < 0) n = 0;
    change(st.dataset.lineKey, n);
    el.blur();
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    getCart().then(render).catch(function () {});
  });
  window.addEventListener('pageshow', function () {
    getCart().then(function (c) { setBadge(c.item_count); }).catch(function () {});
  });
})();
